<template>
  <div class="tla-form-group tla-form-group--margin-medium">
    <label
      class="tla-form-group__label tla-form-group__label--required"
      v-html="notesLabel"
      ></label>

    <textarea
      v-model="note"
      class="tla-form-group__textarea"
      v-validate.initial="isMandatory ? { required: true, max: 1000 } : { max: 1000 }"
      :placeholder="notesPlaceholder"
      maxlength="1000"
      ></textarea>

    <span class="tla-form-group__message" :class="getValidationClass('maintenanceRequired', 'message')">
        Please select an option.
    </span>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import {
  Component, Prop, Inject, Watch
} from 'vue-property-decorator';
import { Validator } from 'vee-validate';
import { validationService } from '@/services/ValidationService';
import KeyValue from '@/models/KeyValue';

@Component({})
export default class NotesComponent extends Vue {
  @Inject('$validator') public $validator!: Validator;

  @Prop({ default: null })
  public validationScope!: string;

  @Prop({ default: 'Please enter any additional information' })
  public notesLabel!: string;

  @Prop({ default: 'Please enter any additional information' })
  public notesPlaceholder!: string;

  @Prop({ default: false })
  public isMandatory!: boolean;

  public note: string = '';

  @Watch('note')
  public submitNote() {
    this.$store.dispatch('enquiryModule/submitNote', new KeyValue(this.notesLabel, this.note));
  }

  public getValidationClass(fieldName: string, fieldType: string) {
    return validationService
      .getValidationClass(this.$validator, fieldName, fieldType, false, false, this.validationScope);
  }
}
</script>
